<template>
    <div @click="handleClick" class="video-carousel-item-root clickable">
        <div class="play-icon-wrapper">
            <BaseIcon class="play-icon" size="3x" name="play" />
        </div>
        <img :src="img" height="200" style="object-fit: cover;" />
        <div
            v-if="title"
            class="overlay"
            style="font-size: 10px; line-height: 40px;"
        >
            <h6 class="px-3 py-2 mb-0 text-left font-weight-bold white">
                {{ title }}
            </h6>
        </div>
    </div>
</template>

<script>
import DialogService from '~/services/DialogService';

export default {
    name: 'Videos.CarouselItem',

    props: {
        id: [String, Number],
        title: String,
        img: String,
        videoLink: String,
    },

    methods: {
        handleClick() {
            this.$emit('click');
        },
    },
};
</script>

<style lang="css" scoped>
.video-carousel-item-root {
    position: relative;
}

.video-carousel-item-root:hover > img {
    transform: scale(1.04);
}

.video-carousel-item-root:hover .play-icon {
    opacity: 0.9;
}

.overlay {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    background-color: rgba(0, 0, 0, 0.55);
    color: white;
    box-shadow: 0px -2px 3px 0px rgba(0,0,0,0.75);
}

.video-carousel-item-root > img {
    width: 100%;
    object-fit: cover;
    transition: transform .2s; /* Animation */
}

.play-icon-wrapper {
    position: absolute;
    top: 0; left: 0;
    right: 0; bottom: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: auto;
}

.play-icon {
    z-index: 1;
    color: var(--secondary);
    opacity: 0.6;

    transition: opacity 0.1s linear;
}
</style>
